<template>
  <div class="animated fadeIn">
    <loading :active.sync="disabledField"></loading>
    <notifications group="foo" />
    <b-row>
      <b-col sm="12" md="6" lg="3" v-for="widget in widgets">
        <b-card no-body v-bind:class="cardClass(widget)" style="min-height: 200px;">
          <b-card-body class="pb-0">
           <b-badge v-bind:variant="badgeClass(widget)" class="float-right">{{widget.price}} р/мес</b-badge>
            <h4 class="mb-1">{{widget.name}}</h4>           
            <p>{{widget.description}}</p>
          </b-card-body>
          <b-card-footer>
            <b-row class="align-items-center" v-if="">
              <b-col cols="6" xl class="mb-3 mb-xl-0">
                <b-button  v-bind:to="`/widgets/${widget.alias}`" size="sm" block variant="secondary" :disabled="btnChangeDisabled(widget)">{{btnInfoText(widget)}}</b-button>
              </b-col>
              <b-col cols="6" xl class="mb-3 mb-xl-0">
                <b-button size="sm" block v-bind:variant="btnConnectClass(widget)" v-on:click="changeWidgetStatus(widget)" :disabled="btnChangeDisabled(widget)">{{btnConnectText(widget)}}</b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row><!--/.row--> 
    
  </div>
</template>

<script>
  import WidgetsService from '@/services/WidgetsService'
  import widgetEvents from '@/views/widgets/Widget';

  export default {
    name: 'Shop',
    mixins: [
        widgetEvents
    ],
    data () {
      return {
        domain      : null,
        widgets     : [],
        onLoad      : false,
        curWidget   : null
      }
    },
    methods: {
      async getWidgets () {
        this.disabledField = true;   
        const response = await WidgetsService.fetchWidgets(this.domain);        
        this.widgets = response.data;
        this.disabledField = false;   
      },
      cardClass: function(widget) {
        return widget.active  ? 'bg-primary' : 'bg-light';
      },
      badgeClass: function (widget) {
        return widget.price > 0 ? 'warning' : 'success';
      },
      btnConnectText: function (widget) {
        return widget.active ? 'Отключить' : 'Подключить';
      },
      btnConnectClass: function (widget) {
        return widget.active ? 'danger' : 'success';
      },
      btnInfoText: function (widget) {
        return widget.active ? 'Настроить' : 'Информация';
      },
      btnChangeDisabled (widget){
        return (this.onLoad && this.curWidget == widget._id);
      },
      async changeWidgetStatus (widget){
        this.onLoad = true;
        this.curWidget = widget._id;
        await WidgetsService.updateWidgetStatus(!widget.active, widget._id);
        await this.getWidgets()
        this.onLoad = false;
      }
    },
    mounted () {
      if(this.$route.query.domain) localStorage.domain = this.$route.query.domain;
      if(this.$route.query.apikey) localStorage.apikey = this.$route.query.apikey;
      this.getWidgets();
    },
    computed: {
      widgetHref : (alias) => {
        return '/widget/' + alias
      }
    }
  }
  
</script>